const ClientApi = () => {
    return 'ClientApi'
}

export default ClientApi
